require('../modules/es.aggregate-error');
require('../modules/es.array.iterator');
require('../modules/es.string.iterator');
var path = require('../internals/path');

module.exports = path.AggregateError;
